<template>
  <div class="page-memory">
    <!-- 1. Hero 头图区域 -->
    <MemoryHero />

    <!-- 2. AI 算法帮你加强记忆 (遗忘曲线) -->
    <section class="memory-chart">
      <div class="chart__card">
        <h2 class="chart__title">AI 算法帮你<span class="chart__title--hl">加强记忆</span></h2>
        <p class="chart__desc">
          基于<b>艾宾浩斯遗忘规律</b>与<b>间隔记忆法</b>，kuku 会根据你的掌握程度，自动安排每日新学和复习任务。
        </p>
        <img :src="chartImg" class="chart__img" alt="遗忘曲线图" />
      </div>
    </section>

      <!-- 3. The problem 区域 -->
      <section class="memory-problem">
          <!-- @asset: src/assets/memory-replace/Frame 2135.png -->
          <img :src="problemTitleImg" class="problem__title-img" alt="" />
          <div class="problem__content">
              <!-- @asset: src/assets/memory-replace/Frame 213.png -->
              <img :src="problemBirdImg" class="problem__bird" alt="" />
              <!-- @asset: src/assets/memory-replace/背了又忘.png -->
              <img :src="problemTextImg" class="problem__text-img" alt="" />
          </div>

          <!-- 白色问题列表框 - width:380, radius:20 -->
          <div class="problem__list-card">
              <div class="problem__item">
                  <!-- @asset: src/assets/memory-replace/大脑_brain 1.png -->
                  <img :src="brainIcon" class="problem__icon" alt="" />
                  <span>今天背会了，三天后又像没见过。</span>
              </div>
              <div class="problem__divider" />
              <div class="problem__item">
                  <!-- @asset: src/assets/memory-replace/错题库 1.png -->
                  <img :src="wrongIcon" class="problem__icon" alt="" />
                  <span>错题越来越多，却不知道该先复习哪一个。</span>
              </div>
              <div class="problem__divider" />
              <div class="problem__item">
                  <!-- @asset: src/assets/memory-replace/计划任务 1.png -->
                  <img :src="planIcon" class="problem__icon" alt="" />
                  <span>计划做得很满，但真正坚持下来很难。</span>
              </div>
          </div>

          <!-- Group 4646 黄色横幅（文字已烤入图内） -->
          <div class="problem__banner">
              <img :src="bannerBg" class="problem__banner-bg" alt="" />
          </div>
      </section>

      <!-- 4. What it does 功能区域 -->
      <section class="memory-feature">
          <!-- @asset: src/assets/memory-replace/Frame 2136.png -->
          <img :src="featureTitleImg" class="feature__title-img" alt="" />

          <!-- 小鸟 + 文字 上下布局（小鸟在上，文字在右侧） -->
          <div class="feature__content">
              <!-- @asset: src/assets/memory-replace/Frame 2134.png -->
              <img :src="featureBirdImg" class="feature__bird" alt="" />
              <!-- @asset: src/assets/memory-replace/文字.png -->
              <img :src="featureTextImg" class="feature__text-img" alt="" />
          </div>

          <!-- 功能卡片网格（紧贴文字.png 下方，无缝隙） -->
          <div class="feature__card-wrapper">
              <!-- @asset: src/assets/memory-replace/Group 4640.png -->
              <img :src="featureGridImg" class="feature__grid-img" alt="" />
          </div>
      </section>

      <!-- 5. Daily rhythm 每日节奏 -->
      <section class="memory-rhythm">
          <!-- @asset: src/assets/memory-replace/Frame 2137.png -->
          <img :src="rhythmTitleImg" class="rhythm__title-img" alt="" />

          <!-- 墨镜小鸟 + 文字 左右布局 -->
          <div class="rhythm__content">
              <!-- @asset: src/assets/memory-replace/Frame 212.png -->
              <img :src="rhythmBirdImg" class="rhythm__bird" alt="" />
              <!-- @asset: src/assets/memory-replace/每天只做今日任务.png -->
              <img :src="rhythmTextImg" class="rhythm__text-img" alt="" />
          </div>

          <!-- 时间线卡片（Group 4641 自带白色卡片） -->
          <!-- @asset: src/assets/memory-replace/Group 4641.png -->
          <img :src="rhythmTimelineImg" class="rhythm__timeline-img" alt="" />

          <!-- 黄色横幅（Group 4642，文字已烤入图内） -->
          <!-- @asset: src/assets/memory-replace/Group 4642.png -->
          <img :src="rhythmBannerImg" class="rhythm__banner-img" alt="" />
      </section>

      <!-- ========== 复制区块1（样式独立，替换图片即可） ========== -->
      <section class="memory-rhythm-c1">
          <!-- @asset: src/assets/memory-replace/Frame 2137_copy1.png -->
          <img :src="rhythmC1TitleImg" class="rhythm-c1__title-img" alt="" />
          <div class="rhythm-c1__content">
              <!-- @asset: src/assets/memory-replace/Frame 212_copy1.png -->
              <img :src="rhythmC1BirdImg" class="rhythm-c1__bird" alt="" />
              <!-- @asset: src/assets/memory-replace/每天只做今日任务_copy1.png -->
              <img :src="rhythmC1TextImg" class="rhythm-c1__text-img" alt="" />
          </div>
          <!-- @asset: src/assets/memory-replace/Group 4641_copy1.png -->
          <img :src="rhythmC1TimelineImg" class="rhythm-c1__timeline-img" alt="" />
          <!-- @asset: src/assets/memory-replace/Group 4642_copy1.png -->
          <img :src="rhythmC1BannerImg" class="rhythm-c1__banner-img" alt="" />
      </section>

      <!-- ========== 复制区块2（样式独立，替换图片即可） ========== -->
      <section class="memory-rhythm-c2">
          <!-- @asset: src/assets/memory-replace/Frame 2137_copy2.png -->
          <img :src="rhythmC2TitleImg" class="rhythm-c2__title-img" alt="" />
          <div class="rhythm-c2__content">
              <!-- @asset: src/assets/memory-replace/Frame 212_copy2.png -->
              <img :src="rhythmC2BirdImg" class="rhythm-c2__bird" alt="" />
              <!-- @asset: src/assets/memory-replace/每天只做今日任务_copy2.png -->
              <img :src="rhythmC2TextImg" class="rhythm-c2__text-img" alt="" />
          </div>
          <!-- @asset: src/assets/memory-replace/Group 4641_copy2.png -->
          <img :src="rhythmC2TimelineImg" class="rhythm-c2__timeline-img" alt="" />
          <!-- @asset: src/assets/memory-replace/Group 4642_copy2.png -->
          <img :src="rhythmC2BannerImg" class="rhythm-c2__banner-img" alt="" />
      </section>
  </div>
</template>

<script>
import MemoryHero from '../components/MemoryHero.vue'
import chartImg from '@/assets/memory-replace/Frame 2123.png'
import problemTitleImg from '@/assets/memory-replace/Frame 2135.png'
import problemBirdImg from '@/assets/memory-replace/Frame 213.png'
import problemTextImg from '@/assets/memory-replace/背了又忘.png'
import brainIcon from '@/assets/memory-replace/大脑_brain 1.png'
import wrongIcon from '@/assets/memory-replace/错题库 1.png'
import planIcon from '@/assets/memory-replace/计划任务 1.png'
import bannerBg from '@/assets/memory-replace/Group 4646.png'
import featureTitleImg from '@/assets/memory-replace/Frame 2136.png'
import featureBirdImg from '@/assets/memory-replace/Frame 2134.png'
import featureTextImg from '@/assets/memory-replace/文字.png'
import featureGridImg from '@/assets/memory-replace/Group 4640.png'
import rhythmTitleImg from '@/assets/memory-replace/Frame 2137.png'
import rhythmBirdImg from '@/assets/memory-replace/Frame 212.png'
import rhythmTextImg from '@/assets/memory-replace/每天只做今日任务.png'
import rhythmTimelineImg from '@/assets/memory-replace/Group 4641.png'
import rhythmBannerImg from '@/assets/memory-replace/Group 4642.png'

/* ===== 复制区块1（_copy1）：替换时只改下面这 5 个文件名即可 ===== */
import rhythmC1TitleImg from '@/assets/memory-replace/Frame 2137_copy1.png'
import rhythmC1BirdImg from '@/assets/memory-replace/Frame 212_copy1.png'
import rhythmC1TextImg from '@/assets/memory-replace/每天只做今日任务_copy1.png'
import rhythmC1TimelineImg from '@/assets/memory-replace/Group 4641_copy1.png'
import rhythmC1BannerImg from '@/assets/memory-replace/Group 4642_copy1.png'

/* ===== 复制区块2（_copy2）：替换时只改下面这 5 个文件名即可 ===== */
import rhythmC2TitleImg from '@/assets/memory-replace/Frame 2137_copy2.png'
import rhythmC2BirdImg from '@/assets/memory-replace/Frame 212_copy2.png'
import rhythmC2TextImg from '@/assets/memory-replace/每天只做今日任务_copy2.png'
import rhythmC2TimelineImg from '@/assets/memory-replace/Group 4641_copy2.png'
import rhythmC2BannerImg from '@/assets/memory-replace/Group 4642_copy2.png'


export default {
  name: 'HomeMemoryAlgo',
  components: {
    MemoryHero
  },
  props: {
    query: { type: Object, default: () => ({}) }
  },
  data() {
      return { chartImg, problemTitleImg, problemBirdImg, problemTextImg, brainIcon, wrongIcon, planIcon, bannerBg, featureTitleImg, featureBirdImg, featureTextImg, featureGridImg, rhythmTitleImg, rhythmBirdImg, rhythmTextImg, rhythmTimelineImg, rhythmBannerImg,
        rhythmC1TitleImg, rhythmC1BirdImg, rhythmC1TextImg, rhythmC1TimelineImg, rhythmC1BannerImg,
        rhythmC2TitleImg, rhythmC2BirdImg, rhythmC2TextImg, rhythmC2TimelineImg, rhythmC2BannerImg }
  }
}
</script>

<style lang="scss" scoped>
@use '@/styles/memory-algo.scss' as *;

.page-memory {
  width: 100%;
  max-width: 100vw;
  margin: 0 auto;
  background-color: $ma-bg;
  color: $ma-black;
  font-family: $ma-font-cn;
  font-size: 14px;
  line-height: 1.5;
  overflow-x: hidden;
  padding-bottom: 40px;

  /* 响应式 */
  @include respond-to(medium) {
    border-radius: 0;
  }
  @include respond-to(large) {
    max-width: 420px;
    margin: 0 auto;
  }
}

/* ---------- 遗忘曲线卡片 ---------- */
.memory-chart {
  margin-top: 0;
  padding: 0 $ma-page-pad;
}

/* 红色边框卡片容器 - width:339, height:473, radius:20, border:2px red */
.chart__card {
  width: 100%;
  max-width: 380px;
  height: 473px;
  margin: 0 auto;
  border-radius: 20px;
  border: 2px solid $ma-primary;
  background: $ma-white;
  padding: 20px 16px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.chart__title {
  font-family: $ma-font-en;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.4;
  color: $ma-black;
  margin: 0 0 12px;
}

.chart__title--hl {
  color: $ma-primary;
}

.chart__desc {
  font-size: 14px;
  line-height: 1.7;
  color: $ma-black;
  margin: 0 0 16px;
  b { font-weight: 800; }
}

.chart__img {
  width: 100%;
  flex: 1;
  object-fit: contain;
  display: block;
}

/* ---------- The problem ---------- */
.memory-problem {
  padding: 20px $ma-page-pad;
}

.problem__title-img {
  display: block;
  width: 100%;
  height: auto;
}

/* 标题图片（The problem） */
.problem__title-img {
  display: block;
  width: 100%;
  height: auto;
}

/* 内容区 - 小鸟+文字 横向布局（与Membership的sec-head一致：space-between） */
.problem__content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 0;
}

.problem__bird {
  width: 110px;
  height: auto;
  flex-shrink: 0;
  object-fit: contain;
}

.problem__text-img {
  max-width: 160px;
  height: auto;
  margin-top: -20px;
}

.problem__text-main {
  font-family: $ma-font-en;
  font-weight: 700;
  font-size: 20px;
  line-height: 1.4;
  color: $ma-black;
  margin: 0;
}

.problem__text-hl {
  font-family: $ma-font-en;
  font-weight: 900;
  font-size: 22px;
  line-height: 1.4;
  color: $ma-primary;
  margin: 4px 0 0;
}

/* 白色问题列表框 - width:380, radius:20 */
.problem__list-card {
  width: 100%;
  max-width: 380px;
  margin: 0 auto;
  border-radius: 20px;
  background: $ma-white;
  padding: 24px 24px;
  box-sizing: border-box;
  margin-top: 0px;
}

.problem__item {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 14px;
  line-height: 1.6;
  color: $ma-black;
}

/* 横线分隔 - width:307, border:1px */
.problem__divider {
  width: 307px;
  max-width: 100%;
  height: 0;
  margin: 16px auto;
  border-top: 1px solid $ma-gray-light;
}

.problem__icon {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
}

/* 黄色横幅 Group 4646 - 紧贴白框无间距 */
.problem__banner {
  position: relative;
  width: 100%;
  max-width: 380px;
  margin: -2px auto 0;
  border-radius: 16px;
  overflow: hidden;
}

.problem__banner-bg {
  display: block;
  width: 100%;
  height: auto;
}

.problem__banner-text {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: left;
  font-family: $ma-font-cn;
  font-size: 12px;
  font-weight: 600;
  line-height: 2.4;
  color: $ma-black;
  padding: 22px 20px;
  box-sizing: border-box;
}

.banner-hl {
  color: $ma-primary;
}

/* ---------- What it does 功能区域 ---------- */
.memory-feature {
  padding: 0 $ma-page-pad;
}

.feature__title-img {
  display: block;
  width: 100%;
  height: auto;
}

.feature__content {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 8px 0 0;
}

.feature__bird {
    width: 110px;
    height: auto;
    flex-shrink: 0;
    object-fit: contain;
}

.feature__text-img {
    max-width: 160px;
    height: auto;
    margin-top: -20px;
}

/* 功能卡片网格容器 - 紧贴文字.png 下方，无缝隙 */
.feature__card-wrapper {
  margin-top: 0;
}

.feature__grid-img {
  display: block;
  width: 100%;
  height: auto;
}

/* ---------- Daily rhythm 每日节奏 ---------- */
.memory-rhythm {
  padding: 0 $ma-page-pad;
  margin-top: 24px;
}

.rhythm__title-img {
  display: block;
  width: 90%;
  height: auto;
}

.rhythm__content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 0;
}

.rhythm__bird {
  width: 110px;
  height: auto;
  flex-shrink: 0;
  object-fit: contain;
}

.rhythm__text-img {
  flex: 1;
  max-width: 150px;
  height: auto;
}

/* 时间线卡片图（自带白色卡片背景，直接平铺） */
.rhythm__timeline-img {
  display: block;
  width: 100%;
  height: auto;
}

/* 黄色横幅图（文字已烤入） */
.rhythm__banner-img {
  display: block;
  width: 100%;
  height: auto;
  margin-top: -2px;
}

/* ---------- 复制区块1（样式独立） ---------- */
.memory-rhythm-c1 {
  padding: 0 $ma-page-pad;
  margin-top: 24px;
}
.rhythm-c1__title-img {
  display: block;
  width: 100%;
  height: auto;
}
.rhythm-c1__content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 0;
}
.rhythm-c1__bird {
  width: 110px;
  height: auto;
  flex-shrink: 0;
}
.rhythm-c1__text-img {
  flex: 1;
  max-width: 260px;
  height: auto;
}
.rhythm-c1__timeline-img {
  display: block;
  width: 100%;
  height: auto;
}
.rhythm-c1__banner-img {
  display: block;
  width: 100%;
  height: auto;
  margin-top: -2px;
}

/* ---------- 复制区块2（样式独立） ---------- */
.memory-rhythm-c2 {
  padding: 0 $ma-page-pad;
  margin-top: 24px;
}
.rhythm-c2__title-img {
  display: block;
  width: 100%;
  height: auto;
}
.rhythm-c2__content {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 8px 0 0;
}
.rhythm-c2__bird {
  width: 110px;
  height: auto;
  flex-shrink: 0;
}
.rhythm-c2__text-img {
  flex: 1;
  max-width: 140px;
  height: auto;
}
.rhythm-c2__timeline-img {
  display: block;
  width: 100%;
  height: auto;
}
.rhythm-c2__banner-img {
  display: block;
  width: 100%;
  height: auto;
  margin-top: 20px;
  margin-bottom: 200px;
}
</style>
